(function() {
	'use strict';

	if(avastGlobals.detect.browser.isEdgeChromium) {
		document.querySelector('body').classList.add('is-edge-chromium');
	}

})();
